interface OfflineBannerProps {
  state: 'connecting' | 'open' | 'reconnecting' | 'offline';
}

export function OfflineBanner({ state }: OfflineBannerProps) {
  if (state === 'open') return null;
  const txt =
    state === 'connecting'
      ? 'Conectando ao servidor...'
      : state === 'reconnecting'
        ? 'Conexao instavel - reconectando...'
        : 'Sem conexao com o servidor (dados podem estar desatualizados)';
  const tone =
    state === 'offline' ? 'bg-[--color-crit-soft] text-[--color-crit] border-[--color-crit]/40' : 'bg-[--color-warn-soft] text-[--color-warn] border-[--color-warn]/40';
  return (
    <div className={`border-b px-6 py-1.5 text-center text-xs font-medium tracking-wide ${tone}`}>
      <span className="mr-2 inline-block h-2 w-2 rounded-full bg-current animate-pulse-soft" />
      {txt}
    </div>
  );
}
